import { z } from 'zod';
/**
 * The capturable fields an admin can choose to include on a form, beyond
 * the two that are always present — first and last name (docs section 9
 * "Lead Capture"). Kept to the same set `publicCaptureLeadSchema` already
 * accepts server-side; a form's `fields` config only controls what the
 * *visitor* sees and what's required, never the wire shape, so adding a
 * field to a form never needs an API change.
 */
export const webFormFieldKeySchema = z.enum(['email', 'phone', 'companyName', 'jobTitle', 'message']);
export const webFormFieldConfigSchema = z.object({
    key: webFormFieldKeySchema,
    label: z.string().trim().min(1).max(80),
    required: z.boolean(),
});
export const WEB_FORM_FIELD_DEFAULT_LABELS = {
    email: 'Email',
    phone: 'Phone',
    companyName: 'Company',
    jobTitle: 'Job title',
    message: 'How can we help?',
};
export const WEB_FORM_MAX_FIELDS = 5;
export const DEFAULT_WEB_FORM_FIELDS = [
    { key: 'email', label: WEB_FORM_FIELD_DEFAULT_LABELS.email, required: true },
    { key: 'phone', label: WEB_FORM_FIELD_DEFAULT_LABELS.phone, required: false },
    { key: 'companyName', label: WEB_FORM_FIELD_DEFAULT_LABELS.companyName, required: false },
    { key: 'jobTitle', label: WEB_FORM_FIELD_DEFAULT_LABELS.jobTitle, required: false },
    { key: 'message', label: WEB_FORM_FIELD_DEFAULT_LABELS.message, required: false },
];
//# sourceMappingURL=fields.js.map